<template>
  <div
    class="hover:bg-selection relative group-scope"
    :class="[{'bg-selection': isOpen}, {'rounded-b-10': !isTeamAccount}]"
  >
    <ButtonModule
      ref="buttonRef"
      text="Color"
      :prefix="`icon-design mr-15 text-main-color ${classes}`"
      :suffix="`icon-keyboard_arrow_right text-main-color ${classes} ml-auto`"
      class="text-app-color px-12 py-11 w-full"
      @click="showColorPicker"
    />
    <div
      v-show="isOpen"
      ref="contentRef"
      class="absolute bg-primary rounded-10 px-12 py-11 w-215 shadow-dropdown"
      :style="position"
    >
      <div class="flex items-center justify-between">
        <p class="text-15 ml-6 font-semibold">Pick a color</p>
        <ButtonModule
          v-if="hasColor"
          text="remove color"
          :has-hover="true"
          prefix="icon-color_reset mr-5 text-app-color"
          :icon-has-margin="false"
          class="text-app-color rounded-4 p-5 text-12"
          :class="isDarkMode ? 'bg-hover' : 'bg-grey-550'"
          @click="removeColor"
        />
      </div>
      <div class="-mx-5 flex flex-wrap">
        <div
          v-for="color in colors"
          :key="color.id"
          class="mt-10 mx-5 w-40 h-40 rounded-full flex"
          :style="`background-color: ${color.main}`"
          @click="setColor(color)"
        >
          <i v-if="hasColor === color.name" class="icon-check mx-auto mt-7 text-22 text-white font-bold" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, nextTick, reactive, ref } from 'vue'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { useStore } from 'vuex'
import defaultColors from '@/core/colors'

export default defineComponent({
  components: {
    ButtonModule
  },

  props: {
    book: Object
  },

  emits: ['close'],

  setup (props, { emit }) {
    const { dispatch, getters } = useStore()

    const colors = defaultColors.bookColors

    const isOpen = ref(false)
    const contentRef = ref(null)
    const buttonRef = ref(null)

    const hasColor = computed(() => props.book.color)
    const isDarkMode = computed(() => getters.isDarkMode)
    const isTeamAccount = computed(() => getters.isTeamAccount)
    const isTwilightTheme = computed(() => getters.isTwilightTheme)

    const classes = computed(() => {
      if (isTwilightTheme.value) return isOpen.value ? 'text-app-color' : 'group-scope-hover:text-app-color'
      return ''
    })

    const position = reactive({
      top: '0px',
      left: '100%'
    })

    const setPosition = () => {
      const buttonRect = buttonRef.value.$el.getBoundingClientRect()
      const contentRect = contentRef.value.getBoundingClientRect()

      if (window.innerWidth - buttonRect.right - contentRect.width < 0) {
        position.top = '100%'
        position.right = '0'
        position.left = null
      }
    }

    const showColorPicker = () => {
      isOpen.value = !isOpen.value

      nextTick(() => {
        setPosition()
      })
    }

    const setColor = (color) => {
      emit('close')
      dispatch('editBook', {
        ...props.book,
        color: color.name
      })
    }

    const removeColor = () => {
      emit('close')
      dispatch('editBook', {
        ...props.book,
        color: null
      })
    }

    return {
      colors,
      isOpen,
      position,
      // computed
      classes,
      hasColor,
      isDarkMode,
      isTeamAccount,
      // refs
      contentRef,
      buttonRef,
      // func
      showColorPicker,
      setColor,
      removeColor
    }
  }
})
</script>
